import { createSlice } from "@reduxjs/toolkit";
import { checkMessageStatus } from '../../Helpers/Chat/Recall';

const initialState = {
    "id" : null,
    "data": {}
}
const recentChatStatus = createSlice({
    name:'recentChatStatus',
    initialState,
    reducers:{
        addrecentChatStatus: (_state, payload)=>{
            const { id, data } = payload.payload || {}
               return {
                ..._state,
                "id": id,
                "data": {
                    msgId: data.messageId,
                    status: checkMessageStatus(data.participants)
      }
               }
        }
    }
});

export default recentChatStatus.reducer
export const addRecentChatStatus = recentChatStatus.actions.addrecentChatStatus
